import { Injectable } from '@angular/core';
import { AddressDetails } from './AddressDetails';

// Document Reverse: https://geocode.farm/our-apis/reverse-geocoding/
// Document Look up: https://geocode.farm/our-apis/forward-geocoding/

@Injectable({
  providedIn: 'root'
})

export class SclMapGeoCodeFarmService {

  constructor() {
  }

  autocompleteUrl = 'https://api.geocode.farm/forward/';
  geocodeUrl = 'https://api.geocode.farm/reverse/';
  autocompleteBox;
  apiKey;
  apiKeyReverse;
  waitTime = 5000; // miliseconds
  country;
  language;
  state;
  initObj;
  preText = '';
  autocompleteStreet;

  reverse( coor, cb, cbErr, cbTimeout) {
    if ( this.apiKeyReverse == null) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('GeocodeFarm address reverse: apiKeyReverse is null');
      }
      return;
    }

    let link = `${this.geocodeUrl}?key=${this.apiKeyReverse}&lat=${coor[1]}&lon=${coor[0]}`;
    // link = this.getLinkOptions( link);

    // logger.info("Codefarm reverse , link = " + link);
    this.initObj.httpService.getAPI(link, {timeout: this.waitTime})
      .subscribe(data => {
          // let data = results.data;
          console.log(`***** data = `, data);
          if (data && data.STATUS && data.STATUS.status === 'SUCCESS') {
            const suggestions = data.RESULTS;
            const streetData: any = new AddressDetails();
            let cbLat = coor[1]; let cbLon = coor[0];
            if (suggestions?.result && suggestions?.result[0]) {
              const address = suggestions?.result[0];
            
              if (address) {
                streetData.properties.streetNo = address.house_number;
                streetData.properties.street = address.street_name;
                streetData.properties.suburb = address.locality;
                streetData.properties.postcode = address.postal_code;
                streetData.properties.country = address.country;
                streetData.properties.state = address.admin_1;
                streetData.geometry.coordinates = [ coor[0], coor[1] ]; // lon, lat

                if (address.latitude) {
                  cbLat = parseFloat(address.latitude);
                }
                if (address.longitude) {
                  cbLon = parseFloat(address.longitude)
                }
              }
            }
            
            

            if (cb && typeof cb === 'function') {
              cb(streetData, { lat: cbLat, lng: cbLon });
            }
          } else {
            if (cbErr && typeof cbErr === 'function') {
              cbErr('Codefarm reverse Error');
            }
          }
        },
        err => {
          if (err.status === -1) {
            if (cbTimeout && typeof cbTimeout === 'function') {
              cbTimeout();
            }
          } else {
            // logger.info(err);
            if (cbErr && typeof cbErr === 'function') {
              cbErr('Codefarm reverse Error');
            }
          }
        }
      );
  }

  lookUp(params, cb, cbErr, cbSelectOption, cbRemoveStreet, cbTimeout ) {

    if (params == null || params.length < 1) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('params is invalid, [0] : autocompleteBox');
      }
      return;
    }
    if (this.autocompleteBox == null) {
      this.autocompleteBox = params[0];
    }


    if (params.length > 1) {
      this.search(params[1], cb, cbErr, cbTimeout);
    }

  }

  removeLookUp() {
    const id = this.initObj.keyName + 'MapGeoCodFarm';
    const lst = document.querySelectorAll('#' + id);
    if (lst && lst.length > 0) {
      for (let i = 0; i < lst.length; i++) {
        lst[i].remove();
      }
    }
    this.autocompleteBox = null;
  }
  removeStreet(cb) {
    if (this.autocompleteStreet == null) {
      this.autocompleteStreet = document.getElementById('#' + this.initObj.keyName + 'autocomplete');
      // angular.element(element).find('#' + scope.fieldName +'autocomplete');
    }

    if (this.autocompleteStreet == null) {
      if (cb && typeof cb === 'function') {
        cb();
      }
      return;
    }
    this.autocompleteStreet.value = '';

    if (cb && typeof cb === 'function') {
      cb();
    }
  }

  search(sPartialAddress, cb, cbErr, cbTimeout) {
    if ( this.apiKey == null) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('GeocodeFarm address lookup: apiKey is null');
      }
      return;
    }
    if ( sPartialAddress == null ) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('text is null');
      }
      return;
    }
    const results = [];

    const newText = sPartialAddress.trim();
    if (newText === this.preText) {
      if (cb && typeof cb === 'function') {
        cb([]);
      }
      return;
    }

    this.preText = newText;
    
    if ( newText.length < 3 ) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('text is less than 3 words');
      }
      return;
    }

    // sPartialAddress += '&country=au&lang=en'; // can't find these parameters on document updated 22-Mar-2025 at link: https://geocode.farm/our-apis/forward-geocoding/
    sPartialAddress = this.getAddressOptions(sPartialAddress);

    let link = `${this.autocompleteUrl}?key=${this.apiKey}&addr=${sPartialAddress}`;
    // link = this.getLinkOptions(link);

    this.initObj.httpService.getAPI(link, {timeout: this.waitTime})
      .subscribe( (data) => {
          if (data && data.STATUS.status === 'SUCCESS') {
            const suggestions = data.RESULTS;
            
            const predict = suggestions.result;
            const sugg: any = {};
            sugg.street = predict.address.full_address;
            sugg.address = predict.address;
            sugg.coordinates = predict.coordinates;
            results.push(sugg);

            if (cb && typeof cb === 'function') {
              cb(results);
            }
          } else {
            if (cbErr && typeof cbErr === 'function') {
              cbErr('Codefarm lookup Error ');
            }
          }
        },
        err => {
          if (err.status === -1) {
            if (cbTimeout && typeof cbTimeout === 'function') {
              cbTimeout();
            }
          } else {
            if (cbErr && typeof cbErr === 'function') {
              cbErr('Codefarm lookup Error ');
            }
          }

        });
  }

  selectionOption(tpl, model, cb) {
    const address = tpl.address;
    const coordinates = tpl.coordinates;
    const obj: any = new AddressDetails();

    obj.properties.streetNo = address.house_number;
    obj.properties.street = address.street_name;
    obj.properties.suburb = address.locality;
    obj.properties.postcode = address.postal_code;
    obj.properties.country = address.country;
    obj.properties.state = address.admin_1;

    const lat = parseFloat(coordinates.lat);
    const lon = parseFloat(coordinates.lon);
    obj.geometry.coordinates = [lon, lat];


    if (cb && typeof cb === 'function') {
      cb(obj);
    }
  }

  getAddressOptions( addressString) {
    if (this.country) { addressString += ',+' + this.country; }
    // if (this.language) { link += '&lang=' + this.language; } // not find language in document link: https://geocode.farm/our-apis/forward-geocoding/
    if (this.state) { addressString += ',+' + this.state; }

    return addressString;
  }

}
